import React, {Component, Fragment} from 'react';
import FormDatePicker from './FormDatePicker.js';
import FormBool from './FormBool.js';
import ReactTable from 'react-table';
import {Button, Input, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import CurrencyInput from 'react-currency-input';
import BatchUploader from './BatchUploader.js';
import 'react-table/react-table.css';

// TODO MAKE DUPLICATION WORK, THEN FIGURE OUT ISSUES WITH PERFORMANCE LOSS.
class EditTable extends Component {
	constructor(props) {
		super(props);

		this.getOptions = this.getOptions.bind(this);
		this.renderEditable = this.renderEditable.bind(this);
	}

	getOptions(valueArray) {
		let options = [];
		valueArray.forEach((option, i) => {
			if (i === 0) {
				options.push(
					<option key="0" value="0">
						No Selection
					</option>
				);
			}

			options.push(
				<option key={i + 1} value={option.id}>
					{option.value}
				</option>
			);
		});

		return options;
	}

	renderEditable(cellInfo) {
		// console.log(cellInfo);
		switch (this.props.parentTable) {
		case 'pc':
			switch (cellInfo.column.Header) {
			// selects:
			case 'Model': {
				let options = this.getOptions(
					this.props.routeData.all_pc_model_types
				);

				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
									// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}
						}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}

			case 'Initial Warranty': {
				let options = this.getOptions(
					this.props.routeData.all_warranty_periods
				);
				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
								// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}

			case 'Care': {
				let options = this.getOptions(
					this.props.routeData.all_warranty_types
				);
				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
								// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}

			case 'Update Type': {
				let options = this.getOptions(
					this.props.routeData.all_update_types
				);

				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
								// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}

			case 'TS Ver.': {
				let options = this.getOptions(
					this.props.routeData.all_ts_admin_versions
				);

				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
								// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}
			case 'Exit Method': {
				let options = this.getOptions(
					this.props.routeData.all_exit_methods
				);

				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
								// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}

			case 'Install Type': {
				let options = this.getOptions(
					this.props.routeData.all_installation_types
				);

				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
								// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}

			case 'Orientation': {
				let options = this.getOptions(
					this.props.routeData.all_orientations
				);

				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
								// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}

			// dates:
			case 'Enclosure Ship':
			case 'Install Date':
			case 'Expected Ship Date':
			case 'PC Ship':
			case 'Start':
			case 'Expire':
			case 'Sale Date':
				return (
					<FormDatePicker
						table={true}
						parentID={this.props.data[cellInfo.index].bronco.id_prefix}
						label={cellInfo.column.id}
						date={this.props.data[cellInfo.index][cellInfo.column.id]}
						humanLabel={cellInfo.column.Header}
						triggerFormDateChange={this.props.triggerFormDateChange}
					/>
				);
			case 'Reseller':
			case 'Wait To Ship': {
				let usefulValue = this.props.data[cellInfo.index][cellInfo.column.id] === '1';
				return (
					<label className="switch miniswitch">
						<div className="switchText">
							<div className="switchLft">Yes</div>
							<div className="switchRt">No</div>
						</div>
						<input
							type="checkbox"
							checked={usefulValue}
							id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
								cellInfo.column.id
							]}`}
							onChange={(event) => {
								this.props.triggerFormBoolChange(event, usefulValue);
							}}
						/>
						<span className="slider" />
					</label>
				);
			}

			case 'Fee':
			case 'PC Revenue': {
				let id = `${this.props.data[cellInfo.index].bronco.id_prefix}-${[cellInfo.column.id]}`;
				return (
					<CurrencyInput
						className="rounded-0 textinput"
						onChangeEvent={(_event, _maskedValue, floatValue) => {
							// don't wanto the dollar sign in the db.
							let nextValue = floatValue.toString();
							this.props.triggerFormCurrencyChange(nextValue, id);
						}}
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
						id= {`${this.props.data[cellInfo.index].bronco.id_prefix}-${cellInfo.column.id}`}
						prefix="$"
						precision="2"
						allowEmpty={true}
					/>
				);
			}
			case 'Delete':
				return (
					<Button
						color="danger"
						onClick={() => {
							if (window.confirm('Are you sure you want to delete this record?')) {
								this.props.deleteSingleRecord(
									'pc',
									this.props.data[cellInfo.index].ID
								);
							}
						}}
					>
								Delete
					</Button>
				);
			case 'Duplicate':
				return (
					<Button
						color="info"
						className="duplicate-btn"
						onClick={() => {
							console.log(this.props.data[cellInfo.index]);
							this.props.updateDupTargetAndType(this.props.data[cellInfo.index], 'PC');
							this.props.setHardwareDuplicationModal(true);
						}}
					>
								Duplicate
					</Button>
				);
			case `Project ID`:
				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[cellInfo.column.id]}`}
						className="rounded-0 table-input"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
						onChange={(e) => {
							this.props.triggerFormValueChange(e);
						}}
					/>
				);
			default:
				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
						onChange={(e) => {
							this.props.triggerFormValueChange(e);
						}}
					/>
				);
			}

		case 'monitor':
			switch (cellInfo.column.Header) {
			// selects:
			case 'Model': {
				let options = this.getOptions(
					this.props.routeData.all_monitor_model_types
				);

				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
								// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}
			case 'Initial Warranty': {
				let options = this.getOptions(
					this.props.routeData.all_warranty_periods
				);
				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
								// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}
			case 'Care': {
				let options = this.getOptions(
					this.props.routeData.all_warranty_types
				);
				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
								// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}
			case 'Touch Type': {
				let options = this.getOptions(
					this.props.routeData.all_touch_monitors
				);
				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						onChange={
							(event) => {
								if (event.target.value == 0) {
								// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
						type="select"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					>
						{options}
					</Input>
				);
			}
			// dates:
			case 'Monitor Ship':
			case 'Start':
			case 'Expire': {
				return (
					<FormDatePicker
						table={true}
						parentID={this.props.data[cellInfo.index].bronco.id_prefix}
						label={cellInfo.column.id}
						date={this.props.data[cellInfo.index][cellInfo.column.id]}
						humanLabel={cellInfo.column.Header}
						triggerFormDateChange={this.props.triggerFormDateChange}
					/>
				);
			}
			case 'Fee': {
				let id = `${this.props.data[cellInfo.index].bronco.id_prefix}-${[cellInfo.column.id]}`;
				return (
					<CurrencyInput
						className="rounded-0 textinput"
						onChangeEvent={(_event, maskedValue, floatValue) => {
							let nextValue = floatValue.toString();
							this.props.triggerFormCurrencyChange(nextValue, id);
						}}
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
						prefix="$"
						id= {`${this.props.data[cellInfo.index].bronco.id_prefix}-${cellInfo.column.id}`}
						precision="2"
						allowEmpty={true}
					/>
				);
			}

			case 'Duplicate':
				return (
					<Button
						color="info"
						className="duplicate-btn"
						onClick={() => {
							console.log(this.props.data[cellInfo.index]);
							this.props.updateDupTargetAndType(this.props.data[cellInfo.index], 'Monitor');
							this.props.setHardwareDuplicationModal(true);
						}}
					>
								Duplicate
					</Button>
				);
			case 'Delete':
				return (
					<Button
						color="danger"
						onClick={() => {
							if (window.confirm('Are you sure you want to delete this record?'))  {
								this.props.deleteSingleRecord(
									'monitor',
									this.props.data[cellInfo.index].ID
								);
							}
						}}
					>
								Delete
					</Button>
				);
			case `Project ID`:
				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[cellInfo.column.id]}`}
						className="rounded-0 table-input"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
						onChange={(e) => {
							this.props.triggerFormValueChange(e);
						}}
					/>
				);
			default:
				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
						onChange={(e) => {
							this.props.triggerFormValueChange(e);
						}}
					/>
				);
			}
		case 'building':
			switch (cellInfo.column.Header) {
			case 'Delete':
				return (
					<Button
						color="danger"
						onClick={() => {
							this.props.deleteSingleRecord(
								'building',
								this.props.data[cellInfo.index].ID
							);
						}}
					>
								Delete
					</Button>
				);
			default:
				return (
					<Input
						id={`${this.props.data[cellInfo.index].bronco.id_prefix}-${[
							cellInfo.column.id
						]}`}
						className="rounded-0 table-input"
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
						onChange={(e) => {
							this.props.triggerFormValueChange(e);
						}}
						maxLength={255}
					/>
				);
			}
		default:
		}
	}

	render() {
		let betterColumns = this.props.columns.map((column) => {
			column.Cell = this.renderEditable;
			// console.log(column);
			// if (column.Header === 'Description') {
			//   column.width = 500;
			// }
			switch (column.Header) {
			case 'Delete':
				column.width = 50;
				break;
			case 'Expected Ship Date':
				column.width = 150;
				break;
			case 'PC Ship':
				column.width = 110;
				break;
			case 'PC Name':
				column.width = 90;
				break;
			case 'Model':
				column.width = 110;
				break;
			case 'Serial #':
				column.width = 90;
				break;
			case 'Care':
				column.width = 100;
				break;
			case 'Start':
				column.width = 110;
				break;
			case 'Expire':
				column.width = 110;
				break;
			case 'Fee':
				column.width = 50;
				break;
			case 'Description':
				column.width = 300;
				break;
			case 'Update Type':
				column.width = 85;
				break;
			case 'TS Ver.':
				column.width = 50;
				break;
			case 'Exit Method':
				column.width = 80;
				break;
			case 'Install Type':
				column.width = 80;
				break;
			case 'Orientation':
				column.width = 100;
				break;
			case 'Sale Date':
				column.width = 110;
				break;
			case 'PC Trk #':
				column.width = 130;
				break;
			case 'PCDirID':
				column.width = 60;
				break;
			case 'WaitToShip':
				column.width = 80;
				break;
			case 'Monitor Ship':
				column.width = 110;
				break;
			case 'Monitor Trk':
				column.width = 110;
				break;
			case 'Display Name':
				column.width = 150;
				break;
			case 'DNum':
				column.width = 60;
				break;
			case 'Enclosure Ship':
				column.width = 110;
				break;
			default: column.width = 100;
			}
			return column;
		});

		return (
			<div id={this.props.id}>
				<ReactTable
					defaultPageSize={this.props.defaultPageSize}
					data={this.props.data}
					columns={betterColumns}
				/>
			</div>
		);
	}
}

export default EditTable;



// WEBPACK FOOTER //
// ./src/components/EditTable.js